import React from 'react';
import ReactDOM from 'react-dom/client';
import MyLeaderboard from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <MyLeaderboard />
  </React.StrictMode>
);
